{{text}}<span class="color-red" *ngIf="isMandatory">*</span>
